<template>
    <v-layout wrap justify-center align-center>
        <v-flex xs12 pa-0>
            <v-flex xs12 pa-0 text-center :class="[urgentClass, 'ends-container', 'darken-1']">

                <v-flex xs12 v-if="isEnded" class="container">
                    Ended.
                </v-flex>

                <div v-else>
                    <v-flex xs12 class="">
                        <span class="end-title">Finaliza en:</span>
                    </v-flex>

                    <v-flex xs12 >
                        <span class="end-value">{{end}}</span>
                    </v-flex>
                </div>

            </v-flex>
        </v-flex>
    </v-layout>

</template>

<script>
    export default {
        props: ['date'],
        data () {
            return {
                isEnded: false,
                end: null
            }
        },

        computed:{
            urgentClass(){

                var vm = this

                const hoursRegex = /horas/
                const minutesRegex = /minutos/

                if(hoursRegex.test(vm.end)){
                    return 'red'
                }

                if(minutesRegex.test(vm.end)){
                    return 'purple'
                }

                return 'light-green'


            }
        },
        methods: {
            updateRemaining () {

                var vm = this
                vm.end = vm.$moment().to(vm.$moment(vm.date, 'YYYY-MM-DD HH:mm:ss'), true)

            },
        },

        mounted () {
            var vm = this
            vm.updateRemaining()
            vm.timer = setInterval(vm.updateRemaining, 1000 * 60 * 60)
        },

        destroy () {
            clearInterval(this.timer)
        }
    }
</script>

<style scoped>

    .ends-container{
        border-radius: 4px !important;
        border: 2px solid;
        background-color: #fff !important;
    }

    .ends-container.light-green{
        border-color: #60ab4d;
        color: #60ab4d;
    }


    .ends-container.purple{
        border-color: #b2074a;
        color: #b2074a;
    }


    .ends-container.red{
        border-color: #cc3a2f;
        color: #cc3a2f;
    }

    .end-title{
        font-size: .9em;
    }
    .end-value{
        font-size: 1.2em;
        font-weight: bold;
    }
</style>
